import type { DemoScenarioResolved } from 'tio-data/demo/types';
import type { DemoFixtureIdentity, DemoProductConfig, DemoScenario } from 'tio-employee/demo/types';

/** Financial Wellness demo builder. Scaffolding — filled in a later phase. */
export function buildWellnessDemo(
  _config: Extract<DemoProductConfig, { kind: 'wellness' }>,
  _scenario: DemoScenario,
  _identity: DemoFixtureIdentity
): DemoScenarioResolved {
  return { matchers: [], seed: [] };
}
